/**
 * Resets the original image active state for the given viewport index.
 * Shared between Viewport (handleDrop) and Thumbnail (setActiveThumbnail).
 */
export const resetOriginalImageState = (
    originalImageActiveState,
    activeViewportIndex,
    setOriginalImageActiveState
) => {
    if (originalImageActiveState[activeViewportIndex]) {
        const temp = originalImageActiveState.map((state, index) => {
            if (index === activeViewportIndex) return false;
            return state;
        });
        setOriginalImageActiveState(temp);
    }
};

/**
 * Builds a series data object from a stack and its related stacks.
 * Used for thumbnail click, lateral series load, and initial viewport load.
 */
export const buildSeriesDataFromStack = (
    stack,
    originalStack,
    heatmapStack,
    outlineStack,
    modality,
    viewportIndex,
    thumbnailIndex
) => ({
    stack,
    studyId: stack.studyId,
    studyIdDisplay: stack.studyIdDisplay,
    series: stack.stackId,
    modality,
    seriesModality: stack.seriesModality,
    viewportIndex,
    patientId: stack.patientId,
    patientAge: stack.patientAge,
    patientSex: stack.patientSex,
    patientName: stack.patientName,
    studyDescription: stack.studyDescription,
    studyDate: stack.studyDate,
    thumbnailIndex,
    originalStack,
    heatmapStack,
    outlineStack,
    orderId: stack.orderId,
    clientName: stack.clientName,
});

/**
 * Extracts series data from a drag-and-drop event into a structured object.
 * Parses the single serialized JSON blob set by handleOnDrag.
 * Used by Viewport and MPRViewport handleDrop.
 */
export const extractSeriesDataFromDragEvent = (e, viewportIndex) => {
    const seriesData = JSON.parse(e.dataTransfer.getData("application/series-data"));
    seriesData.viewportIndex = viewportIndex;
    return seriesData;
};